import { ALL_EXTRA_FIELDS_FILTER, ALL_EXTRA_FIELDS_WITH_TYPE_BOOLEAN } from "../contanst/filter-fields";
import { CHIP_LABELS, CHIP_RELATIONS } from "../contanst/chips";
import { FilterFormFieldsEnum } from "../enum";
import { SYMBOL_PLATFORM_MAP } from "@src/constant/ab-testing/platform";

type ResultGroupingExtraField = {
  label: string;
  name: string | FilterFormFieldsEnum;
  relation: string;
  value: string[];
  order: number;
};
export const FILTER_OUT_USER_NAME = "filterOutUser";

export const getGroupingExtraField = (extraFilterValues: Record<string, any>) => {
  const getFilterOutUserResult: ResultGroupingExtraField = {
    label: "Filter out user result",
    relation: "with",
    name: FILTER_OUT_USER_NAME,
    value: [] as string[],
    order: 0,
  };
  const getOtherResult: ResultGroupingExtraField[] = [];

  ALL_EXTRA_FIELDS_FILTER.forEach((field, index) => {
    if (extraFilterValues[field]) {
      if (ALL_EXTRA_FIELDS_WITH_TYPE_BOOLEAN.includes(field)) {
        getFilterOutUserResult.value.push(CHIP_LABELS[field]);
      } else if (field === FilterFormFieldsEnum.EXTRA_PLATFORM) {
        getOtherResult.push({
          label: CHIP_LABELS[field],
          relation: CHIP_RELATIONS[field],
          value: extraFilterValues[field].map((item: string) => SYMBOL_PLATFORM_MAP[item]),
          name: field,
          order: index + 1,
        });
      } else {
        getOtherResult.push({
          label: CHIP_LABELS[field],
          relation: CHIP_RELATIONS[field],
          value: extraFilterValues[field],
          name: field,
          order: index + 1,
        });
      }
    }
  });

  return getFilterOutUserResult.value.length > 0 ? [getFilterOutUserResult, ...getOtherResult] : getOtherResult;
};
